import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CustomOptionPopupComponent } from './custom-option-popup/custom-option-popup.component';
import { ProductService } from 'src/app/services/product.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'calsoft-custom-option',
  templateUrl: './custom-option.component.html',
  styleUrls: ['./custom-option.component.scss']
})
export class CustomOptionComponent implements OnInit {

  @Input() customtype: any;
  @Input() productCustomized: any;
  @Input() productId: any;
  customProductElament: Object;

  @Input() quoteItem: any;

  @Input() selection:any=[];
  @Input() customProductMap = new Map<any, any>();

  @Input() productMap:any;
  productType: string;
  constructor(
    private productService: ProductService,
    public dialog: MatDialog,
  ) { 

   
    
  }

  @Output() getCheckedValue: EventEmitter<any> = new EventEmitter<any>();

  @Input() salesFlatQuoteItemOption: any = [];


  ngOnInit(): void {
  
    this.getcustomProductResource(this.productCustomized);
    this.customProductMap=this.customProductMap


    this.salesFlatQuoteItemOption=this.quoteItem;

  
  }



  getcustomProductResource(i) {
    if(i!=null){
    this.productService.getcustomProductValue(i).subscribe(
      data => {
        this.customProductElament = data;

      }
    )
    }
  }



  updateCheckedOptions(event, j, primaryIndex, secondaryIndex,
     secondaryId,
     final,type,secondaryKey) {
    let entityId = this.customProductElament[primaryIndex].productCustomizationList[secondaryIndex]['entityId']
    let childKey = this.customProductElament[primaryIndex].productCustomizationList[secondaryIndex]['key']
    if (event.checked) {

      this.selection.push(secondaryId);

      this.setValueForSalesItemOption(this.customProductElament[primaryIndex].productCustomizationList[secondaryIndex],secondaryId)
      this.customProductMap.set(secondaryKey, childKey);

    } else {
      this.customProductMap.delete(secondaryKey);
      let index = this.salesFlatQuoteItemOption.findIndex(x => x.index == secondaryId);
      this.salesFlatQuoteItemOption.splice(index, 1);
      index = this.selection.findIndex(x => x == secondaryId);
      this.selection.splice(index, 1);
      this.getCheckedValue.emit(this.salesFlatQuoteItemOption);
    }


  }

  // updateCheckedOptions(event, j, primaryIndex, secondaryIndex, secondaryId, final) {
  //   let entityId = this.customProductElament[primaryIndex].productCustomizationList[secondaryIndex]['entityId']
  //   let childKey = this.customProductElament[primaryIndex].productCustomizationList[secondaryIndex]['key']
  //   if (event.checked) {
  //     this.customProductMap.set(primaryIndex, secondaryId);
  //     let price = final;
  //   } else {
  //     this.customProductMap.delete(primaryIndex);
  //     let index = this.salesFlatQuoteItemOption.findIndex(x => x.code == childKey);
  //     this.salesFlatQuoteItemOption.splice(index, 1);
  //   }
  // }


  // saree(i, entityId, price, childKey,primaryIndex) {
  //   if (window.innerWidth > 768) {

  //     let dialogRef = this.dialog.open(CustomOptionPopupComponent, {
  //       width: '600px',
  //       data: { page: i, entityId: entityId, value: price, childKey: childKey,primaryIndex }
  //     });

  //     dialogRef.disableClose = true;
  //     dialogRef.afterClosed().subscribe(result => {
  //       this.setValueForSalesItemOption(result)

  //     });

  //   }
  //   else {
  //     let dialogRef = this.dialog.open(CustomOptionPopupComponent, {
  //       minWidth: '100vw', height: '100vh',
  //       data: { page: i, entityId: entityId, value: price, childKey: childKey,primaryIndex:primaryIndex }
  //     });

  //     dialogRef.disableClose = true;
  //     dialogRef.afterClosed().subscribe(result => {
  //       this.setValueForSalesItemOption(result)

  //     });
  //   }



  // }

  setValueForSalesItemOption(finalValue,index) {
    let object = {
      productId: this.productId,
      code: finalValue.key,
      value: finalValue.value,
      additional: finalValue.additional,
      additionalInfoGiven: finalValue.additionalInfoGiven,
      index:index,
      materialCost:finalValue.materialCost,
      additionalCost:finalValue.additionalCost,
    }

    if(this.salesFlatQuoteItemOption==undefined){
      this.salesFlatQuoteItemOption=[]
    }

    this.salesFlatQuoteItemOption.push(object);



    this.getCheckedValue.emit(this.salesFlatQuoteItemOption);

  

  }

}

